import { Model } from "@mcleod/core";
import { AutogenLayoutBillToOverrideTable } from "./autogen/AutogenLayoutBillToOverrideTable";

export class BillToOverrideTable extends AutogenLayoutBillToOverrideTable {

    override async onLoad(): Promise<void> {
        const callingFromCarrier = this.mainDataSource.layoutName === "lme/dispatch/Carrier";
        if (callingFromCarrier) {
            this.removeSMC3ColumnsFromTable();
            return;
        }

        if (!await this.isContractManagementControlActive()) {
            this.removeSMC3ColumnsFromTable();
        }
    }

    private removeSMC3ColumnsFromTable(): void {
        const smc3Captions = ["SMC3 Account Number", "SMC3 Payer Override", "SMC3 Payment Terms"];
        for (const caption of smc3Captions) {
            const column = this.tableBillToOverride.getColumnByCaption(caption);
            if (column) {
                this.tableBillToOverride.removeColumn(column);
            }
        }
    }

    private async isContractManagementControlActive(): Promise<boolean> {
        const path = "lme/powerbroker/contract-management-control";
        const vendorSMC3LtlApiId = "SLA";
        const response = await Model.searchSingleRecord(path, { id: vendorSMC3LtlApiId });
        return "Y" === response?.data.is_active || false;
    }
}
